export const GA_ID = "G-L2XCV3BZ9Q";

// Pageview tracking (SPA)
export const pageview = (url: string) => {
    if (typeof window === "undefined") return;

    window.gtag("config", GA_ID, {
        page_path: url,
    });
};

// Event tracking
export const event = ({
                          action,
                          category,
                          label,
                          value,
                      }: {
    action: string;
    category?: string;
    label?: string;
    value?: number;
}) => {
    if (typeof window === "undefined") return;

    window.gtag("event", action, {
        event_category: category,
        event_label: label,
        value,
    });
};